module.exports = __webpack_public_path__ + "img/03.ae2c5159.png";